<template>
  <div v-if="profile.token" class="logined">
    <div class="block">
      <el-avatar :size="50" :src="profile.image"></el-avatar>
    </div>
    <div class="welcome">
      <p class="name">尊敬的：{{ profile.nickName }}</p>
      <p>欢迎来到山河医学考试网</p>
    </div>
  </div>
  <div v-else class="left-news-top">
    <div class="log-top">
      <div class="block">
        <el-avatar :size="50" v-lazy="profile.image"></el-avatar>
      </div>
      <div class="welcome">
        <p>尊敬的学员</p>
        <p>欢迎来到山河医学考试网</p>
      </div>
    </div>
    <div class="log-botton">
      <el-button-group>
        <RouterLink target="_blank" to="/login"
          ><el-button type="primary">登录</el-button></RouterLink
        >

        <RouterLink target="_blank" to="/login"
          ><el-button type="primary">注册</el-button></RouterLink
        >
      </el-button-group>
    </div>
  </div>
</template>

<script>
import { useStore } from "vuex";
import { computed, ref } from "vue";
export default {
  setup() {
    const store = useStore();
    //计算并获取登录后用户信息数据
    const profile = computed(() => {
      return store.state.user.profile;
    });
    return { profile };
  },
};
</script>

<style lang="less" scoped>
.left-news-top {
  height: 125px;
  background: rgb(253, 247, 247);
  //justify-content: center;

  .log-top {
    width: 100%;
    height: 65px;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
  }
  .log-botton {
    width: 100%;
    height: 55px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.logined {
  display: flex;
  align-items: center;
  // width: 250px;

  flex-direction: column;
  justify-content: space-around;
  height: 125px;
  background: rgb(253, 247, 247);
  .welcome {
    width: 250px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .name {
      width: 150px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>
